<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <DefaultTmpl mode="mobile_search">
        <template v-slot:main>
            <head-utils title="Menu"/>

            <div class="menu-container">
                <transition name="menu">
                    <ul v-if="show" class="menu">
                        <li v-for="(menu, idx) in menuItems"
                            :key="idx"
                            ref="fatherMenu">

                            <router-link v-ripple-tap v-if="!menu.submenu" :to="menu.to" class="item">
                                <svg-icon :icon="menu.icon" class="icon-left"/>
                                <span>{{menu.label}}</span>
                            </router-link>
                            <span v-else v-ripple-tap class="item" @click="expand(idx)">
                                <svg-icon :icon="menu.icon" class="icon-left"/>
                                <span>{{menu.label}}</span>
                                <svg-icon icon="angle-up" class="icon-right"/>
                            </span>

                            <div v-if="menu.submenu" class="smenu">
                                <router-link v-ripple-tap v-for="(item, idx2) in menu.submenu" :to="item.to" :key="idx2">
                                    <svg-icon :icon="item.icon" class="icon-left"/>
                                    <span>{{item.label}}</span>
                                </router-link>
                            </div>
                        </li>
                    </ul>
                </transition>

                <div class="actions">
                    <button type="button" v-ripple-tap v-if="$appStorage.userIsProfile(['admin', 'admin_all', 'admin_view', 'backoffice'])" class="btn btn-dark w-s-n" @click="showFinMov">
                        <svg-icon icon="cash-register"/><br/>
                        Lançamento
                    </button>

                    <button type="button" v-ripple-tap class="btn btn-secondary w-s-n" @click="addFile">
                        <svg-icon icon="file-alt"/><br/>
                        Arquivos
                    </button>

                    <router-link v-ripple-tap to="/users/profile" class="btn btn-primary w-s-n">
                        <svg-icon icon="id-card"/><br/>
                        Meu Perfil
                    </router-link>

                    <button type="button" v-ripple-tap class="btn btn-danger w-s-n" @click="signOut">
                        <svg-icon icon="sign-out-alt"/><br/>
                        Sair do App
                    </button>
                </div>
            </div>

        </template>
        <template v-slot:footer>
            <BottomMenuMob v-if="$appUtils.isMobile()" />
        </template>
    </DefaultTmpl>
</template>

<script>
    import DefaultTmpl from '@/templates/DefaultTmpl'
    import StorageUtils from '@/utils/StorageUtils'
    import BottomMenuMob from '@/components/particles/BottomMenuMob'
    import menuItems from '@/components/menu.json'
    import {createNamespacedHelpers, mapMutations} from 'vuex'
    import {EventBus} from "../utils/EventBus"
    const {mapActions} = createNamespacedHelpers('users');


    export default {
        name: "MenuMobile",
        components: {DefaultTmpl, BottomMenuMob},
        data() {
            return {
                show: false,
                items: []
            }
        },
        methods: {
            confirmLogout() {
                if (confirm('Deseja realmente sair do sistema?')) {
                    this.logout();
                }
            },
            expand(idx) {
                this.items[idx].active = !this.items[idx].active;
                this.$refs.fatherMenu[idx].classList = this.items[idx].active ? 'active' : '';
            },
            signOut() {
                this.addModal({title: 'Sair do Sistema', size: 'small', body: 'Deseja realmente sair do sistema?', buttons: [
                        {type: 'ok', class: 'btn btn-theme-1 btn-sm', method: id => {
                                this.destroyModal(id);
                                this.logout();
                            }},
                        {type: 'close', label: 'Não', focus: true, method: this.destroyModal}
                    ]});
            },
            addFile() {
                EventBus.showCustomerGroupFile(() => {}, {});
            },
            showFinMov() {
                EventBus.showFinMov(() => {}, {entity: {}});
            },
            ...mapActions(['logout']),
            ...mapMutations(['addModal', 'destroyModal'])
        },
        mounted() {
            menuItems.forEach(i => {
                if (i.submenu) i.submenu = i.submenu.filter(s => !s.requireAnyProfiles || StorageUtils.userIsProfile(s.requireAnyProfiles));

                if (i.requireAnyProfiles) {
                    if (StorageUtils.userIsProfile(i.requireAnyProfiles))
                        this.items.push({...i, active: false})
                } else {
                    this.items.push({...i, active: false})
                }
            });
            this.show = true;
        },
        computed: {
            menuItems() {
                return this.items
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../assets/css/variables";

    .menu-container {
        overflow: hidden;
        overflow-y: auto;
        height: calc(100vh - 110px);
    }

    ul.menu {
        list-style: none;
        text-decoration: none;
        margin: 0;
        padding: 0;
        background-color: $theme_color_eleven;
        width: 100%;
        color: white;

        li {
            width: 100%;
            overflow: hidden;

            &:not(:first-child) {
                border-top: 1px solid $theme_color_two;
            }

            &.active svg.icon-right {
                transform: rotateZ(180deg);
            }

            &.active > .smenu {
                max-height: 15em;
            }
        }

        .item {
            padding: 10px 15px;
            display: block;
            background: $theme_color_one;
            position: relative;
            color: white;
            text-decoration: none;
            text-transform: uppercase;

            svg {
                width: 1em;
                height: 1em;
                transition: all .3s ease;

                &.icon-left {
                    margin-right: 16px;
                }

                &.icon-right {
                    float: right;
                    margin-top: 5px;
                }
            }
        }

        .smenu {
            background: $theme_color_eleven;
            overflow: hidden;
            max-height: 0;
            transition: max-height 1s linear;
            transition-delay: unset;

            a {
                padding: 10px 20px;
                width: 100%;
                display: block;
                font-size: .8em;
                margin: 4px 0;
                position: relative;
                transition: color .2s ease;
                color: $theme_color_six;
                text-decoration: none;
                text-transform: uppercase;


                svg {
                    width: 1em;
                    height: 1em;
                    margin-right: 10px;
                }
            }
        }
    }

    .actions {
        margin-top: 50px;
        display: flex;
        overflow-x: auto;
        flex-wrap: nowrap;
        margin-right: 5px;
        padding: 10px;

        button, a{
            &:not(:first-child) {
                margin-left: 5px;
            }

            svg {
                width: 2em;
                height: 2em;
            }
        }
    }

    .menu-enter-active, .menu-leave-active {
        transition: all .5s;
    }
    .menu-enter, .menu-leave-to {
        transform: translateX(-300px);
    }
</style>
